import React, { useState } from "react";
import "./RotatePuzzle.css";
import IMG1 from "../assets/img/bee.png";
import IMG2 from "../assets/img/apple.jfif";
import IMG3 from "../assets/img/dog.jpg";
import IMG4 from "../assets/img/flowers.webp";
import IMG5 from "../assets/img/ball.jpg";
import IMG6 from "../assets/img/nemo.webp";
import IMG7 from "../assets/img/duck.avif";
import IMG8 from "../assets/img/powerpuff_girls.jpg";

const gridSize = 3;
const tileSize = 100;

const imageOptions = [IMG1, IMG2, IMG3, IMG4, IMG5, IMG6, IMG7, IMG8];

export default function RotatePuzzle() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [tiles, setTiles] = useState([]);

  const startGameWithImage = (img) => {
    setSelectedImage(img);
    const shuffledTiles = Array.from(
      { length: gridSize * gridSize },
      () => Math.floor(Math.random() * 4) * 90
    );
    setTiles(shuffledTiles);
  };

  const rotateTile = (index) => {
    const updatedTiles = [...tiles];
    updatedTiles[index] += 90;
    setTiles(updatedTiles);
  };

  const isSolved =
    tiles.length > 0 && tiles.every((angle) => angle % 360 === 0);

  const getBackgroundPosition = (index) => {
    const row = Math.floor(index / gridSize);
    const col = index % gridSize;
    return `-${col * tileSize}px -${row * tileSize}px`;
  };

  return (
    <div className="rotate-puzzle-container">
      <h2>Image Rotate Puzzle</h2>

      {!selectedImage ? (
        <>
          <h4>Select an image to start the game:</h4>
          {/* <div className="image-options"> */}
          <div className="image-options-grid">
            {imageOptions.map((img, idx) => (
              <div
                key={idx}
                className="image-option"
                onClick={() => startGameWithImage(img)}
              >
                <img
                  src={img}
                  alt={`Puzzle ${idx + 1}`}
                  width={100}
                  height={100}
                />
              </div>
            ))}
          </div>
          {/* </div> */}
        </>
      ) : (
        <>
          <h5>Game Instructions</h5>
          <h6>
            Rotate each puzzle piece to complete the full picture.
            <br />
            Tap on each square to rotate. Good luck!
          </h6>

          <div className="puzzle-grid">
            {tiles.map((deg, index) => (
              <div
                key={index}
                className="tile"
                onClick={() => rotateTile(index)}
                style={{
                  transform: `rotate(${deg}deg)`,
                  backgroundImage: `url(${selectedImage})`,
                  backgroundPosition: getBackgroundPosition(index),
                  backgroundSize: `${gridSize * tileSize}px ${
                    gridSize * tileSize
                  }px`,
                }}
              />
            ))}
          </div>

          {isSolved && <p className="solved-msg">🎉 Puzzle Solved!</p>}
        </>
      )}
    </div>
  );
}
